import { AxiosPromise } from 'axios';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import SubscriberFormComponent, { initalValuesProps } from 'system/components/subscriber/form';
import { subscriberCrumbs } from '../constants';

const SubscriberNewPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const onCancel = () => {
    navigate('/sistema/eventmanager/sottoscrittore');
  };
  const insertSottoscrittore = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/sottoscrittore`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });
  const onSubmit = useCallback((formValues: initalValuesProps) => {
    (
      insertSottoscrittore({
        data: {
          descrizione: formValues?.description,
        },
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/sottoscrittore');
    });
  }, []);
  return (
    <>
      <Breadcrumbs items={[...subscriberCrumbs, { name: 'Nuovo Sottoscrittore' }]} />
      <SubscriberFormComponent
        onOk={onSubmit}
        title="Aggiungi  un nuovo sottoscrittore"
        onCancel={onCancel}
      />
    </>
  );
};
SubscriberNewPage.displayName = 'Subscriber new page';
export default SubscriberNewPage;
